module.exports = __webpack_public_path__ + "img/gamemore_bg.e9ba5a7a.jpg";